module.exports = __webpack_public_path__ + "static/alchemist-a6231e1d70242e06b69aab42a589ef80.png";